import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSort = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.49728 12H14.4973M5.49728 16.0017H10.5M5.49728 7.99832H18.5024",
		stroke: "#111827",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgSort);
export default ForwardRef;
